var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66667 3.33301H18.3333C19.2535 3.33301 20 4.07919 20 4.99967V14.9997C20 15.9202 19.2538 16.6663 18.3333 16.6663H1.66667C0.74618 16.6663 0 15.9198 0 14.9997V4.99967C0 4.07919 0.74618 3.33301 1.66667 3.33301ZM16.1111 14.9997C16.1111 13.7712 17.1049 12.7775 18.3333 12.7775V7.2219C17.1049 7.2219 16.1111 6.22815 16.1111 4.99967H3.88889C3.88889 6.22815 2.89514 7.2219 1.66667 7.2219V12.7775C2.89514 12.7775 3.88889 13.7712 3.88889 14.9997H16.1111Z",
    fill: "#007A3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88897 5H16.1112C16.1112 6.22917 17.1042 7.22222 18.3334 7.22222V12.7778C17.1049 12.7778 16.1112 13.7715 16.1112 15H3.88897C3.88897 13.7715 2.89522 12.7778 1.66675 12.7778V7.22222C2.89522 7.22222 3.88897 6.22847 3.88897 5ZM7.2223 10C7.2223 11.841 8.46605 13.3333 10.0001 13.3333C11.5348 13.3333 12.7779 11.8403 12.7779 10C12.7779 8.15903 11.5341 6.66667 10.0001 6.66667C8.46605 6.66667 7.2223 8.15903 7.2223 10Z",
    fill: "#007A3D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.7504bfbad441c52658a352d575383e1e.svg";
export { ForwardRef as ReactComponent };